// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"45c3514ff81eefe73dc4","112":"2041aa5f97cfbe844008","113":"09c777ed4f3f96497f68","175":"f5ef7808592bb8dcf469"}[chunkId] + ".chunk.js";
};